module.exports = __webpack_public_path__ + "img/scythe-silver.e4fb6dad.svg";